/**
 * Authorization.js
 *
 * Copyright (c) apploft. GmbH
 */
function adminToken(res) {
  var keyAdminAuth = res.keyAdminAuth || res.security.keyAdminAuth;

  if (typeof keyAdminAuth !== 'string') {
    return null;
  }

  return keyAdminAuth;
}

export { adminToken };